import React, { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import {
  SelectStringInput,
  SelectNumberInput,
} from '../../../../../select-input';
import { Button, Col, Dropdown, Input, MenuProps, Row, notification, Tag } from 'antd';
import axios from 'axios';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfEducationContext,
  SkillListContext,
  UserEducationDataContext,
} from '../../../../../../../context';
import EditEducation from '../edit-education';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import DeleteModal from '../../../../../modal/delete';

interface EducationDetailProps {
  education_id: number;
  school_name: string;
  degree_name: string;
  passing_year: number;
  grade: number;
  show_in_resume: boolean;
}

const EducationDetail: React.FC<EducationDetailProps> = ({
  education_id,
  school_name,
  degree_name,
  passing_year,
  grade,
  show_in_resume
}: EducationDetailProps): JSX.Element => {
  const [iseditable, setIsEditable] = useState<boolean>(false);
  const { userEducationData, setUserEducationData } = useContext(
    UserEducationDataContext
  );
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const { numberOfEducation, setNumberOfEducation } = useContext(NumberOfEducationContext)

  const openNotification = (notificationType: 'success' | 'info' | 'warning' | 'error') => {
    notification[notificationType]({
      message: notificationType === 'info' ? `Deleting education item!` : (notificationType === 'success' ? `Deleted education item Successfully` : (notificationType === 'error' ? `An error occured while deleting education item` : "")),
    });
  };


  const handleDelete = () => {
    openNotification('info');
    let reqBody = {};
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/educations';
      reqBody = { profile_id: employeeId, education_id, status: 3 };
    } else {
      url = '/api/v1/profile/educations';
      reqBody = { education_id, status: 3 };
    }
    axiosInstance
      .post(url, reqBody)
      .then((response) => {
        const orderedEducations = response.data.order.map((educationId: number) =>
          response.data.educations.find((education: any) => education.education_id === educationId)
        ).filter((item: any) => item !== undefined);
        setUserEducationData(orderedEducations);
        setNumberOfEducation(orderedEducations.length);
        openNotification('success');
      })
      .catch((error) => {
        openNotification('error');
      });
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <div
          onClick={(e) => {
            setIsEditable(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Edit</p>
        </div>
      ),
      key: '0',
    },
    {
      label: (
        <div
          onClick={() => {
            setIsDeleteModalOpen(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Delete</p>
        </div>
      ),
      key: '1',
    },
  ];

  return (
    <div>
      {isDeleteModalOpen ? (
        <DeleteModal
          {...{
            isModalOpen: isDeleteModalOpen,
            setIsModalOpen: setIsDeleteModalOpen,
            handleDelete: handleDelete,
          }}
        />
      ) : (
        <></>
      )}
      {iseditable ? (
        <EditEducation
          {...{
            education_id,
            school_name,
            degree_name,
            passing_year,
            grade,
            setIsEditable,
            show_in_resume
          }}
        />
      ) : (
        <Row
          key={education_id}
          className={styles.row}
          gutter={{ xs: 8, sm: 16 }}
          style={{ margin: '5px', marginBottom: '10px' }}
        >
          <div style={{ display: "flex", alignItems: "center", position: "absolute", bottom: "5px", right: "5px" }}>
            {
              show_in_resume ? (
                <Tag color="success">
                  Show in resume: Yes
                </Tag>
              ) : (
                <Tag color="error">
                  Show in resume: No
                </Tag>
              )
            }
          </div>
          <Col span={12}>
            <Row>
              <h1 className={styles['skill-text']}>
                <b>{degree_name}</b>
              </h1>
            </Row>
            <Row>
              <p className={styles['institute-name']}>{school_name}</p>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <p>
                <span className={styles.title}>Passing Year : </span>
                <span className={styles.value}>{passing_year}</span>
              </p>
            </Row>
            <Row>
              <p>
                <span className={styles.title}>Cgpa : </span>
                <span className={styles.value}>{grade}</span>
              </p>
            </Row>
          </Col>
          {iseditable ? (
            <></>
          ) : (
            <Dropdown
              menu={{ items }}
              trigger={['click']}
              placement="bottomLeft"
            >

              <Button
                type="text"
                style={{
                  position: 'absolute',
                  right: '5px',
                  border: 'hidden',
                  textDecoration: 'blue',
                  top: "10px"
                }}

              >
                <img
                  src="/more_vert.png"
                  style={{
                    marginLeft: 'auto',
                    marginRight: '0px',
                    height: '15px',
                    width: '5px',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}
                />
              </Button>

            </Dropdown>
          )}
        </Row>
      )}
    </div>
  );
};

export default EducationDetail;
